import {motion}  from "framer-motion/dist/framer-motion";
import  React from "react";
export default function Pulmon(){
    const svgVariants={
        start:{
            opacity:0,
            pathLength:0
        },
        finished:{
            opacity:1,
            pathLength:1,
            transition:{
                duration:2,
                ease:"easeInOut"
            }
        }
    }
return(
<>
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="300.000000pt" height="300.000000pt" viewBox="0 0 1027.000000 1280.000000"
 preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
fill="#09B8FF" stroke="none">
<motion.path 
variants={svgVariants}
initial="start"
animate="finished"
d="M4676 12790 c-37 -12 -73 -46 -98 -94 -23 -46 -22 -106 7 -237 17
-77 18 -95 6 -165 -12 -75 -11 -82 9 -134 20 -50 21 -61 11 -115 -13 -68 -7
-143 35 -414 29 -185 33 -271 20 -451 -8 -113 -7 -129 10 -160 16 -30 19 -70
25 -275 4 -132 15 -376 23 -542 11 -201 16 -425 14 -675 -3 -316 0 -390 15
-486 31 -203 17 -314 -52 -417 -46 -68 -235 -288 -281 -328 -52 -44 -110 -63
-127 -41 -32 44 -58 216 -73 500 -23 440 -49 571 -155 784 -23 47 -92 182
-153 301 -94 185 -113 231 -132 315 -12 55 -32 135 -45 179 -52 174 -248 437
-399 536 -114 75 -283 108 -452 89 -138 -15 -204 -34 -319 -90 -125 -61 -209
-124 -354 -265 -174 -169 -263 -285 -741 -970 -163 -234 -306 -545 -379 -827
-28 -110 -61 -297 -61 -350 0 -16 -23 -50 -66 -99 -419 -471 -614 -998 -590
-1597 5 -151 4 -166 -13 -191 -30 -42 -109 -204 -146 -299 -60 -157 -92 -295
-149 -639 -52 -312 -61 -400 -60 -608 l0 -190 52 -233 c28 -128 92 -391 141
-585 147 -578 160 -674 136 -1068 -19 -314 -16 -368 31 -533 20 -69 34 -143
34 -174 0 -48 4 -58 34 -88 31 -31 31 -33 12 -36 -16 -2 -22 -11 -24 -38 -3
-45 70 -412 84 -417 5 -2 18 3 28 10 17 13 18 18 7 65 -12 48 -8 92 7 92 4 -1
24 -50 44 -111 l36 -110 -25 -12 c-13 -6 -31 -23 -38 -37 -13 -25 -12 -30 11
-64 62 -91 91 -189 140 -461 61 -348 84 -420 162 -516 26 -32 70 -100 98 -151
48 -87 53 -94 98 -110 59 -21 72 -32 153 -136 70 -89 99 -108 188 -118 35 -4
70 -1 111 11 82 24 180 124 245 250 25 50 108 209 184 355 l137 265 74 34
c143 66 186 114 250 278 48 124 100 192 227 296 57 48 112 98 121 111 22 34
46 139 46 202 0 31 -10 78 -25 118 -31 82 -32 106 -4 106 11 0 49 17 84 39 54
32 79 58 154 157 143 190 373 429 526 546 89 68 120 105 158 188 45 100 72
129 185 202 164 107 196 181 212 501 6 124 19 240 35 326 26 141 32 271 14
334 -5 21 -30 61 -53 91 -65 79 -73 96 -50 113 277 201 405 380 449 630 9 48
20 201 26 340 13 297 6 384 -47 623 -33 144 -37 179 -35 275 6 252 6 253 -33
365 -46 133 -76 277 -83 405 -6 108 4 255 17 255 4 0 13 -14 19 -31 14 -41 25
-38 183 50 263 145 394 238 519 367 66 69 149 180 162 217 2 6 39 -21 83 -61
99 -91 153 -118 311 -153 120 -27 188 -53 225 -86 14 -12 16 -29 12 -106 -11
-221 -28 -375 -79 -732 -64 -448 -74 -528 -84 -723 -14 -263 4 -414 89 -732
60 -224 65 -248 96 -425 33 -188 61 -297 96 -377 27 -60 40 -75 140 -157 60
-50 116 -95 125 -99 13 -8 10 -19 -20 -78 -19 -38 -47 -107 -63 -154 -26 -79
-28 -96 -28 -250 -1 -150 2 -174 27 -265 40 -145 82 -222 216 -401 94 -126
134 -190 185 -297 l66 -137 83 -60 c209 -153 217 -162 357 -382 92 -144 157
-221 209 -247 20 -10 70 -24 110 -30 86 -13 127 -30 124 -51 -1 -8 -10 -44
-19 -80 -36 -145 14 -304 142 -448 26 -30 101 -98 168 -152 153 -124 163 -135
266 -287 l85 -127 55 -11 c73 -15 108 -34 158 -88 53 -58 106 -166 172 -347
73 -203 123 -298 185 -353 73 -66 200 -79 301 -31 103 49 208 172 298 352 20
40 54 89 77 109 54 49 81 99 130 234 22 63 58 144 80 180 33 55 39 74 39 120
0 46 4 59 25 79 39 36 82 183 254 870 245 976 256 1042 312 1935 17 271 20
399 16 630 -3 181 0 403 9 590 34 734 11 888 -197 1370 -123 286 -131 313
-139 500 -6 120 -20 234 -58 460 -28 165 -56 343 -63 395 l-11 95 -86 115
c-107 142 -186 235 -272 320 -100 99 -160 170 -186 221 -13 26 -48 133 -79
239 -93 321 -163 517 -245 690 -43 91 -95 211 -116 267 -34 90 -44 107 -81
134 -23 18 -64 59 -91 93 -26 34 -84 105 -127 159 -103 131 -159 175 -389 311
-177 105 -253 159 -421 300 -205 170 -520 198 -770 68 -49 -26 -97 -64 -160
-127 -76 -75 -99 -106 -142 -190 -55 -109 -69 -149 -138 -389 -59 -207 -97
-301 -216 -531 -154 -299 -178 -369 -284 -850 -37 -165 -69 -303 -72 -307 -9
-15 -59 -7 -98 15 -48 27 -81 76 -124 182 -18 44 -39 89 -45 100 -12 19 -17
75 -32 396 -6 121 -4 146 15 223 l22 86 -23 71 -22 70 23 90 c23 87 23 96 16
367 -6 254 -5 288 14 405 24 148 26 206 6 262 -11 31 -12 48 -4 76 8 26 8 51
0 88 -15 71 -13 144 5 221 12 47 17 130 20 300 3 214 5 246 30 355 26 113 28
134 29 380 1 254 2 262 28 343 15 46 27 91 27 102 0 29 -45 75 -97 100 -59 28
-155 30 -375 6 -188 -20 -215 -20 -383 4 -149 21 -222 24 -269 10z"/>
</g>
</svg>
</>
);
} 